import type { MapPing } from "../types";

export const PLAYER_PING_DURATION_MS = 3_000;

export function isPlayerPingActive(ping: MapPing | undefined, now = Date.now()): ping is MapPing {
  return Boolean(ping && Number.isFinite(ping.commandAt) && now - ping.commandAt < PLAYER_PING_DURATION_MS);
}
